<template>
      <b-col md="15">
        <b-card>
          <div slot="header">
            Activity Log: 
          </div>
          <b-tabs >
            <b-tab active>
              <template slot="title">
                <i class="cui-wrench icons font-2xl d-block mt-2"></i>
              </template>
                    <!-- <h5>{{action}} by user: {{username}}, fullname {{fullname}}</h5>
                    {{createdAt}} 12324{{timezone}} -->

                <div v-for="item in logData" v-bind:key="item.id">
                    <ul class="">
                      <li class="">
                        <div class="">
                          <p>
                          Action: {{ item.action }},<br/> 
                          By Username: {{ item.user_name }},<br/> 
                          <small>Timestamp: {{item.createdAt}} </small>
                          </p>
                        </div>
                      </li>
                    </ul>
                </div>

            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
</template>

<script>

// export default {
//     data () {
//         return {
//             username: '',
//             password: '',
//             submitted: false
//         }
//     },
//     computed: {
//     },
//     created () {
//       var routerPage = this.$router.currentRoute.name;
//       console.log(routerPage);
//       var data = this.getByRouterPage({ routerPage });
//       console.log(data);
//     },
//     methods: {
//         ...mapActions('activityLog', ['getByRouterPage'])
//     }
// };

import { mapState, mapActions } from 'vuex'
import { apigClient } from '@/shared/api';
import moment from 'moment';

export default {
  name: "activityLog",
  components: {
  },
  data: function () {
    var object_id;
    var routerPage = this.$router.currentRoute.name;
    console.log(routerPage);
    switch (routerPage)
      {
        case "userEdit": object_id = localStorage.getItem('page_user_id'); break;
        default: 
      }
    return {
      logData: [],
      object_id: object_id || null,
        id: null,
        fullName: null,
        user_id: null,
        action: null,
        password: null
    }
  },
  created: function() {
      //   setTimeout(() => { 
      // async () => {
      // const logData = await this.get({ object_id });
      // }
      //   } );
  },
  methods: {
    ...mapActions('activityLog', ['get']),
    getactivityLogData : function() {
        var method = 'GET';
        var pathTemplate = '/activityLogs/'+this.object_id;
        var additionalParams ={};
        var pathParams = {};
        var that = this;
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results){
          that.logData  = results["data"]["data"];
          console.log('invoke directly'+results["data"]["data"])
        //This is where you would put a success callback
        }).catch( function(err){
          console.log('ERROR ! Cannot get data:' + err);
          //This is where you would put an error callback
        });
    },
  },
  mounted: function(){
    this.getactivityLogData();
  },
}
</script>
